// @flow

import React from "react";
import moment from "moment";
import ReactImageFallback from "react-image-fallback";
import I18n from "../../i18n/I18n";
import styles from "./ReportCards.scss";
import Button from "../common/button/Button";
import genImg from "../../images/common/genReport.svg";
import CONFIG from "../../config";

type Props = {
  data: Array<Object>,
  exportReports: Function,
  isExportLoading: string | boolean
};

const ReportCards = (props: Props) => {
  const data = props.data || "";

  const reportCards = data
    ? data.map((item, index) => {
        const iconImg = `${CONFIG.BASE_IMG_URL}s/misc/seller-lab-static/${
          item.icon_name
        }.svg`;
        const date = item.month;
        const dateFormatted = moment(date).format("MMM, YYYY");
        const weekRange = `${moment()
          .subtract(7, "days")
          .format("Do MMM")} - ${moment().format("Do MMM")}`;
        return (
          <div
            className={`${styles.ctr} ${
              props.reportsType !== 1 ? styles.monthCtr : ""
            }`}
            key={index}
          >
            <div className={styles.cardTitle}>{item.report_name || ""}</div>
            <div className={styles.totalWrapper}>
              <div className={styles.indWrapper}>
                <ReactImageFallback
                  src={iconImg}
                  fallbackImage={genImg}
                  alt=""
                  className={styles.img}
                />
                {props.reportsType === 1 || props.reportsType === 2 ? (
                  <div>
                    <div className={styles.indTitle}>
                      {I18n.getText("reports.no-items", {}, "Total Items")}
                    </div>
                    <div className={styles.content}>
                      <p>{item.no_of_items}</p>
                    </div>
                    {props.reportsType === 2 ? (
                      <div className={styles.weekRange}>
                        <div className={styles.indTitle}>
                          {I18n.getText("reports.week")}
                        </div>
                        <div className={styles.content}>
                          <p>{weekRange}</p>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  <div>
                    <div className={styles.indTitle}>
                      {I18n.getText("reports.vat-month", {}, "month")}
                    </div>
                    <div className={styles.content}>
                      <p>{dateFormatted}</p>
                    </div>
                  </div>
                )}
              </div>

              {/* download button for custom and weekly reports */}
              {(props.reportsType === 1 || props.reportsType === 2) && (
                <div className={styles.buttonWrapper}>
                  <Button
                    variant="transparent"
                    className={styles.dwnldBtn}
                    onClick={() =>
                      props.exportReports(
                        item.report_name,
                        item.download_link,
                        index
                      )
                    }
                  >
                    {props.isExportLoading === item.download_link ? (
                      <div className={styles.loader}> </div>
                    ) : (
                      I18n.getText("reports.download", {}, "Download")
                    )}
                  </Button>
                </div>
              )}

              {/* download button for monthly vat related reports */}
              {props.reportsType === 3 && (
                <div className={styles.monthBtn}>
                  <a href={item.download_zip} target="_blank">
                    <Button variant="transparent" className={styles.dwnldBtn}>
                      {I18n.getText("reports.download", {}, "Download")}
                    </Button>
                  </a>
                </div>
              )}

              {/* text for consolidated reports if delayed is equal 1 */}
              {item.is_delayed === 2 &&
                props.reportsType !== 3 &&
                props.isExportLoading === item.download_link && (
                  <div className={styles.belowText}>
                    {I18n.getText(
                      "reports.is-delayed",
                      {},
                      "This will take some time to download"
                    )}
                  </div>
                )}
            </div>
          </div>
        );
      })
    : "";

  return <div className={styles.wrapper}>{reportCards}</div>;
};

export default ReportCards;



// WEBPACK FOOTER //
// ./src/components/reports/ReportCards.js